import { chatDictationResponseSchema, type ChatDictationResponseDTO } from '@shared/schemas/chat-dictation';
import { apiBaseUrl } from '@/lib/auth-client';
import { ApiError } from '@/lib/api-error';

type ApiErrorPayload = {
  error?: { code?: string; details?: Record<string, unknown>; message?: string };
};

function extensionFor(mimeType: string) {
  if (mimeType.includes('mp4') || mimeType.includes('aac')) {
    return 'm4a';
  }
  if (mimeType.includes('ogg')) {
    return 'ogg';
  }
  return 'webm';
}

/** Sends one recorded clip for transcription. The server never stores the audio. */
export async function transcribeDictation(audio: Blob, signal?: AbortSignal): Promise<ChatDictationResponseDTO> {
  const formData = new FormData();
  formData.append('audio', audio, `dictation.${extensionFor(audio.type)}`);

  const response = await fetch(new URL('/api/chat/dictation', apiBaseUrl), {
    body: formData,
    credentials: 'include',
    method: 'POST',
    signal,
  });
  const payload = await response.json().catch(() => null) as ({ data?: unknown } & ApiErrorPayload) | null;

  if (!response.ok || !payload) {
    throw new ApiError({
      code: payload?.error?.code,
      details: payload?.error?.details,
      message: payload?.error?.message ?? (response.statusText || 'La requête a échoué.'),
      status: response.status,
    });
  }

  return chatDictationResponseSchema.parse(payload.data);
}
